import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GeocodeService } from '@yandex-maps/feature';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DeliverySlotsService } from './delivery-slots.service';

interface DeliveryFormData {
  longitude: number;
  latitude: number;
  weight?: string;
}

@Injectable({
  providedIn: 'root',
})
export class DeliveryCalculatorFormService {
  weight = new FormControl(50);

  form = new FormGroup({
    address: new FormControl(),
    weight: this.weight,
  });

  constructor(
    private geocodeService: GeocodeService,
    private deliverySlotsService: DeliverySlotsService,
  ) {}

  loadTimeSlots(formData: DeliveryFormData): void {
    const { latitude, longitude, weight = this.form.get('weight').value } = formData;
    this.deliverySlotsService.loadDeliverySlots({ longitude, latitude }, +weight);
  }

  onSubmit(): void {
    const address = this.form.get('address').value;
    const weight = this.form.get('weight').value;

    this.getCoordinates(address)
      .pipe(take(1))
      .subscribe((coords) => {
        this.loadTimeSlots({ longitude: coords[1], latitude: coords[0], weight: weight.toString() });
      });
  }

  getCoordinates(address: string): Observable<number[]> {
    return this.geocodeService.getGeoObject(address).pipe(map((geoObject) => geoObject.geometry.getCoordinates()));
  }
}
